import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { inject } from '@angular/core';


export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '/i18n/', '.json');
  }
  
  export function initTranslate(): Promise<unknown> {
    const translate = inject(TranslateService);
    const isBrowser = typeof window !== 'undefined';
    let lang = 'de';
  
    if (isBrowser) {
      lang = localStorage.getItem('preferredLang') || lang;
  
      const urlLang = window.location.pathname.split('/')[1];
      if (urlLang === 'en' || urlLang === 'de') {
        lang = urlLang;
      }
  
      if (!localStorage.getItem('preferredLang')) {
        lang = window.location.hostname.includes('.com') ? 'en' : lang;
      }
    }
  
    translate.setDefaultLang(lang);
    return translate.use(lang).toPromise();
  }
  
  